import {combineReducers} from 'redux'
import isResultReducer from "./isResultReducer"
import {newReducer,DataLinkApiReducer,DataLinkApibyidReducer, DataEmailAzureByNameReducer, DataValidateDateReducer, DataPlanByPassReducer} from "./newReducer"
import {fileReducer} from "./fileReducer"
import planHandleReducer from "./planHandleReducer"
import {planHandleStepReducer, planHandleStepHandleStaffReducer, HistoryReducer, Status_ActionHistory} from "./planHandleStepReducer"
import filterReportReducer from "./filterReportReducer"
import tableReportReducer from './tableReportReducer'
import headerTableReportReducer from './headerTableReportReducer'
//IndexImportHygen
const allPlanHandleReducers = combineReducers({
    isResultReducer,
    newReducer,
    fileReducer,
    planHandleReducer,
    planHandleStepReducer,
    planHandleStepHandleStaffReducer,
    filterReportReducer,
    tableReportReducer,
    headerTableReportReducer,
    HistoryReducer,
    Status_ActionHistory,
    DataLinkApiReducer,
    DataLinkApibyidReducer,
    DataEmailAzureByNameReducer,
    DataValidateDateReducer,
    DataPlanByPassReducer,
    //IndexUsingHygen
})

export default allPlanHandleReducers;